import React from 'react';

const AIBuddy = ({
  isRecording,
  isEviSpeaking,
  isConnected,
  startupSoundPlaying,
  preResponseSoundPlaying,
  isInitializing,
  autoSummaryPending,
  onBuddyClick,
  response,
  showResponse
}) => {
  
  const getBuddyClasses = () => {
    let classes = 'buddy-circle';
    if (isConnected) classes += ' connected';
    if (isRecording) classes += ' listening';
    if (isEviSpeaking) classes += ' speaking';
    if (autoSummaryPending) classes += ' processing';
    if (isInitializing) classes += ' initializing';
    if (startupSoundPlaying) classes += ' startup-sound';
    if (preResponseSoundPlaying) classes += ' thinking';
    return classes;
  };

  const generateCircularDots = () => {
    const dots = [];
    const centerX = 100;
    const centerY = 100;
    
    const rings = [
      { radius: 20, dotSize: 6.5, dotCount: 7, isEdge: false },
      { radius: 35, dotSize: 5, dotCount: 12, isEdge: false },
      { radius: 50, dotSize: 4, dotCount: 16, isEdge: false },
      { radius: 65, dotSize: 4, dotCount: 20, isEdge: false },
      { radius: 80, dotSize: 3, dotCount: 24, isEdge: true },
      { radius: 90, dotSize: 1, dotCount: 28, isEdge: true }
    ];
    
    rings.forEach((ring, ringIndex) => {
      for (let i = 0; i < ring.dotCount; i++) {
        const angle = (i / ring.dotCount) * 2 * Math.PI;
        const x = centerX + ring.radius * Math.cos(angle);
        const y = centerY + ring.radius * Math.sin(angle);
        
        const waveDelay = (i / ring.dotCount) * 2 + (ringIndex * 0.3);
        const spreadDistance = ring.isEdge ? 
          Math.random() * 15 + 5 : 
          Math.random() * 8 + 2;
        
        dots.push(
          <div
            key={`${ringIndex}-${i}`}
            className={ring.isEdge ? 'circle-dot edge' : 'circle-dot-alex'}
            style={{
              width: ring.dotSize + 'px',
              height: ring.dotSize + 'px',
              left: (x - ring.dotSize / 2) + 'px',
              top: (y - ring.dotSize / 2) + 'px',
              animationDelay: waveDelay + 's',
              '--spread-distance': spreadDistance + 'px'
            }}
          />
        );
      }
    });
    
    dots.push(
      <div
        key="center"
        className="circle-dot-alex"
        style={{
          width: '10px',
          height: '10px',
          left: (centerX - 5) + 'px',
          top: (centerY - 5) + 'px',
          animationDelay: '0s',
          '--spread-distance': '3px'
        }}
      />
    );
    
    return dots;
  };
  return (
    <div
      className={`ai-buddy ${isRecording && !isEviSpeaking ? 'listening' : ''}`}
      onClick={onBuddyClick}
    >
      <div className={getBuddyClasses()}>
        <div className="wave-animation"></div>
        <div className="buddy-inner">
          <div className="buddy-core-alex"></div>
        </div>
      </div>

      {/* Circular dots pattern for listening - only show when recording AND not speaking */}
      {isRecording && !isEviSpeaking && (
        <div className="dots-circle">
          {generateCircularDots()}
        </div>
      )}

      {/* Speaking dots (original) */}
      <div className={`dots-alex-container ${isEviSpeaking ? 'show' : ''}`}>
        <div className="dot alex dot-1"></div>
        <div className="dot alex dot-2"></div>
        <div className="dot alex dot-3"></div>
        <div className="dot alex dot-4"></div>
      </div>

      {/* Status indicators */}
      {!isConnected && !startupSoundPlaying && (
        <div className="status-indicator">
          <div className="connection-dot disconnected"></div>
          <span>Ready to chat?</span>
        </div>
      )}

      {/* Calling indicator */}
      {startupSoundPlaying && (
        <div className="status-indicator calling">
          <div className="connection-dot calling-dot"></div>
          <span>Calling</span>
        </div>
      )}

      {/* Response display */}
      {showResponse && response && (
        <div className="response-display">
          <div className="response-text">{response}</div>
        </div>
      )}
    </div>
  );
};

export default AIBuddy;